import { Alert } from "react-bootstrap";

import { switchTenant } from "@/auth/actAs";
import { useAuth } from "@/auth/useAuth";

/** A persistent banner shown while a platform admin is acting inside another
 *  tenant, so it's always obvious they're not in their home context — with a
 *  one-click way back. */
export function ActingAsBanner() {
  const auth = useAuth();
  const actingAs = auth.status === "authenticated" ? auth.user?.acting_as : null;
  if (!actingAs) return null;
  return (
    <Alert variant="warning" className="mb-0 rounded-0 border-0 text-center py-1 small">
      Acting as tenant <strong>{actingAs.tenant_slug}</strong> for support/setup
      (home: {actingAs.home_tenant_slug}).{" "}
      <Alert.Link
        role="button"
        style={{ cursor: "pointer" }}
        onClick={() => switchTenant(null)}
      >
        Return to platform
      </Alert.Link>
    </Alert>
  );
}
